import { render, staticRenderFns } from "./cep-format.vue?vue&type=template&id=86e389cc&scoped=true&lang=pug&"
import script from "./cep-format.vue?vue&type=script&lang=ts&"
export * from "./cep-format.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e389cc",
  null
  
)

export default component.exports